import Vue from "vue";
import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import VueI18Next from "@panter/vue-i18next";
import VueMeta from "vue-meta";

import { capitalize, titlecase } from "@apphq/utils";

import de from "./de.json";
import en from "./en.json";

export const languages = {
  de: "Deutsch",
  en: "English"
};

Vue.use(VueI18Next);
Vue.use(VueMeta);

Vue.filter("capitalize", capitalize);
Vue.filter("titlecase", titlecase);

i18next.use(LanguageDetector).init({
  fallbackLng: "de",
  whitelist: Object.keys(languages),
  debug: process.env.NODE_ENV !== "production",
  resources: {
    de: { translation: de },
    en: { translation: en }
  }
});

const i18n = new VueI18Next(i18next);
export default i18n;
